/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applied_Badge_TitleInputs */

const en_applied_badge_title = /** @type {(inputs: Applied_Badge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already applied`)
};

const de_applied_badge_title = /** @type {(inputs: Applied_Badge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits beworben`)
};

/**
* | output |
* | --- |
* | "Already applied" |
*
* @param {Applied_Badge_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applied_badge_title = /** @type {((inputs?: Applied_Badge_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applied_Badge_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applied_badge_title(inputs)
	return en_applied_badge_title(inputs)
});